<template>
    <div class="">
        
        <template>
            <the-header />
        </template>

        <div class="site-wrapper-reveal">
            <div class="about-banner-wrap banner-space about-us-bg position-relative">
                <div class="banner-overlay"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 ml-auto mr-auto">
                            <div class="about-banner-content text-center">
                                <h1 class="mb-15 text-white">Tenant Resources</h1>
                                <h5 class="font-weight--normal text-white">Proven 15 years’ track record in property management. </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="feature-large-images-wrapper bg-gray section-space--ptb_100">
                <div class="container">
                    <div class="cybersecurity-about-box">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="modern-number-01">
                                    <h4 class="heading sub-title mb-4">For Current Tenants</h4>
                                </div>
                                <div class="cybersecurity-about-text">
                                    <div class="row">
                                        <div class="col-lg-10">                                        
                                            <h3 class="heading mt-30">Pay your rent or request for maintenance with ease</h3>  
                                            <div class="text mt-10">
                                                At Axis Realty, we always strive to ensure your stay with us is as comfortable as possible. We have
                                                provided tenant resources to address any maintenance needs you have as well as help you pay your
                                                rent conveniently and securely.
                                            </div>  
                                            <div class="text">
                                                To make an online payment for your rent or to submit your maintenance request, please log into your portal.
                                            </div>      
                                        </div>
                                    </div>                   
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="modern-number-01">
                                    <h4 class="heading sub-title mb-4">For Prospective Tenants</h4>
                                </div>
                                <div class="cybersecurity-about-text">
                                    <div class="row">
                                        <div class="col-lg-10">                
                                            <h3 class="heading mt-30">Looking for a place to stay?</h3>  
                                            <div class="text mt-10">
                                                Thank you for your interest in renting our properties. Axis Realty is committed to getting you the
                                                perfect place to call home. On average, it takes us between 24 and 48 hours to process your
                                                application. We look forward to a fruitful relationship with you as our tenant.
                                            </div>         
                                        </div>
                                    </div>                                
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 cybersecurity-about-text widget-blog-recent-post mt-30">
                                <h2 class="heading">Maintenance <span class="text-color-primary">Request</span><br>Online Maintenance Request Form</h2> 
                                <div class="text mt-8">
                                    If you have a maintenance issue that is an emergency or is urgent, please call the Maintenance
                                    Hotline straightway on <a href="callTo:3144745277">(314) 474 5277</a>.
                                </div>
                                <div class="text">
                                    Some of the repairs that qualify as an emergency or as urgent include, but are not limited to;
                                </div>
                                <ul class="list-custome mt-8">
                                    <li class="list-item"><a href="javascript:void(0);">a gas leak</a></li>
                                    <li class="list-item"><a href="javascript:void(0);">a burst water pipe or damaged water fitting</a></li>
                                    <li class="list-item"><a href="javascript:void(0);">lack of or faulty electricity, water, or gas supply</a></li>
                                    <li class="list-item"><a href="javascript:void(0);">faulty door locks that put the property’s security at risk</a></li>
                                    <li class="list-item"><a href="javascript:void(0);">lack of hot water</a></li>
                                    <li class="list-item"><a href="javascript:void(0);">serious fire or flood damage</a></li>
                                    <li class="list-item"><a href="javascript:void(0);">defective smoke alarm</a></li>
                                    <li class="list-item"><a href="javascript:void(0);">a broken toilet</a></li>
                                    <li class="list-item"><a href="javascript:void(0);">any other serious issue or fault that compromises the property’s safety or security</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            

            <div class="cta-image-area_one section-space--ptb_80 cta-bg-image_two">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-xl-8 col-lg-7">
                            <div class="cta-content md-text-center">
                                <h3 class="heading">Join our mailing list.</h3>
                                <h4 class="heading">Stay in the know on all new property listings.</h4>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-5">
                            <!-- <div class="cta-button-group--two text-center">
                                <a href="#" class="btn btn--white btn-one"><span class="btn-icon mr-2"><i class="far fa-play-circle"></i></span> Subscribe now</a>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>   

        </div>
            
        <the-footer />
    </div>
</template>

<script>
import TheHeader   from '@/layouts/components/TheHeader.vue'
import TheFooter   from '@/layouts/components/TheFooter.vue'

export default {
  components: {
    TheHeader,
    TheFooter
  },
  data () {
    return {
    }
  },  
  computed: {
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, ('/'))
    }
  }

}
</script>